var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCuba2X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "48px",
    viewBox: "0 0 71 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cuba@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-324.000000, -560.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 70.000000)",
    fillRule: "nonzero",
    id: "Cuba"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(254.000000, 490.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    x: 0.15,
    y: 8.27,
    width: 70,
    height: 11.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    x: 0.15,
    y: 27.77,
    width: 70,
    height: 11.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.78,0.27 L6.51,0.27 C2.99746899,0.27 0.15,3.11746619 0.15,6.62999374 L0.15,8.26999213 L70.15,8.26999213 L70.15,6.62999374 C70.1500021,4.94148449 69.47856,3.32227788 68.283665,2.12925981 C67.0887699,0.936241744 65.4685088,0.267345111 63.78,0.27 Z",
    id: "Shape",
    fill: "#4758A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.15,40.9 C0.15,42.5867769 0.820069505,44.2044678 2.01280087,45.3971991 C3.20553224,46.5899305 4.82322312,47.26 6.51,47.26 L63.78,47.26 C65.4667769,47.26 67.0844678,46.5899305 68.2771991,45.3971991 C69.4699305,44.2044678 70.14,42.5867769 70.14,40.9 L70.14,39.26 L0.14,39.26 L0.15,40.9 Z",
    id: "Shape",
    fill: "#4758A9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#4758A9",
    x: 0.15,
    y: 19.77,
    width: 70,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.27,1.89 C0.915345806,3.09308 0.140117561,4.81823582 0.14,6.63 L0.14,40.9 C0.140117561,42.7117642 0.915345806,44.43692 2.27,45.64 L28.14,23.76 L2.27,1.89 Z",
    id: "Shape",
    fill: "#ED5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.92,27.9 C11.84,28.34 11.58,28.39 11.34,28.01 L10.45,26.59 C10.1576844,26.181976 9.6817294,25.9458724 9.18,25.96 L7.57,26.08 C7.11,26.08 7,25.88 7.31,25.55 L8.49,24.34 C8.80693647,23.9820934 8.87424657,23.467369 8.66,23.04 L7.76,21.43 C7.54,21.04 7.7,20.87 8.12,21.06 L9.84,21.84 C10.2961184,22.0214118 10.8150783,21.9368406 11.19,21.62 L12.44,20.43 C12.77,20.12 13.01,20.23 12.98,20.67 L12.86,22.38 C12.8520302,22.8711945 13.1076698,23.3290563 13.53,23.58 L14.86,24.29 C15.26,24.5 15.23,24.77 14.78,24.87 L13.16,25.25 C12.6659384,25.3701866 12.2801866,25.7559384 12.16,26.25 L11.92,27.9 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuba2X);
export default __webpack_public_path__ + "static/media/Cuba@2x.3e23814aa6c5b95cabbb1fbb583fbf4c.svg";
export { ForwardRef as ReactComponent };